import { NgModule } from '@angular/core';
import { ModuleWithProviders } from '@angular/core';
import { HOTJAR_SETTINGS_TOKEN } from './hotjar-settings.token';
import { HOTJAR_INITIALIZER_PROVIDER } from './hotjar.initializer';

@NgModule({
  imports: [
  ],
  declarations: [],
  exports: [],
  providers: [
  ]
})
export class HotjarModule {
  static forRoot(trackingCode: string, version: number = 6): ModuleWithProviders<HotjarModule> {
    return {
      ngModule: HotjarModule,
      providers: [
        {
          provide: HOTJAR_SETTINGS_TOKEN,
          useValue: {
            trackingCode: trackingCode,
            version: version
          }
        },
        HOTJAR_INITIALIZER_PROVIDER,
      ]
    };
  }
}
